module.exports = __webpack_public_path__ + "static/media/cornhole.f7745fc6.svg";